(() => {
  if (customElements.get('hoya-relaunch')) return;

  class HoyaRelaunch extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      window.clearTimeout(this.timer);
      this.controller = new AbortController();
      const value = this.dataset.expiresAt || '';
      const formatValid = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{2}:\d{2}$/.test(value);
      const localDatetime = value.slice(0, 19);
      const localEpoch = formatValid ? Date.parse(`${localDatetime}Z`) : NaN;
      const calendarValid = Number.isFinite(localEpoch) && new Date(localEpoch).toISOString().slice(0, 19) === localDatetime;
      this.deadline = calendarValid ? Date.parse(value) : NaN;
      const check = () => this.checkExpiry();
      const options = { signal: this.controller.signal };
      window.addEventListener('pageshow', check, options);
      window.addEventListener('focus', check, options);
      document.addEventListener('visibilitychange', check, options);
      this.checkExpiry();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
    }

    checkExpiry() {
      window.clearTimeout(this.timer);
      const remaining = this.deadline - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        (this.closest('.hoya-relaunch-section') || this).hidden = true;
        this.controller?.abort();
        return;
      }
      this.timer = window.setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
    }
  }

  customElements.define('hoya-relaunch', HoyaRelaunch);
})();
